import {
  LiveboardEmbed,
  RuntimeFilterOp,
} from '@thoughtspot/visual-embed-sdk/lib/src/react'
import cx from 'classnames'

import { selectLeftPanelVisibility } from 'common/components/leftPanel/store/leftPanelSlice'
import PageContainer from 'common/components/PageContainer'
import { useAppSelector } from 'common/hooks/redux'

import LeftSection from './LeftSection'
import { EMBED_CLASS_NAME } from './styles'

export const Liveboard = () => {
  const liveboardId = useAppSelector(
    (state) => state.reports.selectedLiveboardId
  )
  const accountId = useAppSelector((state) => state.authStates.accountId)

  const leftPanelVisibility = useAppSelector(selectLeftPanelVisibility)

  return (
    <div
      className={cx('relative overflow-y-auto overflow-x-hidden flex h-full', {
        'ml-30': leftPanelVisibility === 'hidden',
      })}
    >
      <LeftSection />
      <PageContainer>
        <LiveboardEmbed
          className={EMBED_CLASS_NAME}
          liveboardId={liveboardId}
          runtimeFilters={[
            {
              columnName: 'ACCOUNT_ID',
              operator: RuntimeFilterOp.EQ,
              values: [accountId],
            },
            {
              columnName: 'account_id',
              operator: RuntimeFilterOp.EQ,
              values: [accountId],
            },
          ]}
        />
      </PageContainer>
    </div>
  )
}
